import type { User } from '@supabase/supabase-js';

/** Supabase RLS ile aynı site yöneticisi hesabı */
export const SITE_ADMIN_EMAIL = 'forumadmin';

/** Yalnızca giriş yapmış site yöneticisi (forumadmin / forumadmin@…) */
export function isSiteAdmin(user: User | null | undefined): boolean {
  if (!user?.email) return false;

  const email = user.email.toLowerCase().trim();
  const local = email.includes('@') ? email.split('@')[0] : email;

  if (local === SITE_ADMIN_EMAIL || email === SITE_ADMIN_EMAIL) return true;

  const role =
    (user.app_metadata?.role as string | undefined) ??
    (user.user_metadata?.role as string | undefined);
  return role === 'admin' || role === 'site_admin';
}

/** İzlenmeli vb. dahili risk etiketleri */
export function canSeeInternalRiskLabels(user: User | null | undefined): boolean {
  return isSiteAdmin(user);
}
